import { useEffect, useState } from 'react';
import { Card, Empty, ErrorBanner, Stat } from '../components/Layout.jsx';
import { apiFetch } from '../store.js';

export default function Overview() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    apiFetch('/dashboard/overview')
      .then((d) => { if (!cancelled) setData(d); })
      .catch((e) => { if (!cancelled) setError(e); });
    return () => { cancelled = true; };
  }, []);

  const totals = data?.totals || {};
  const perDay = data?.analyses_per_day || [];
  const outcomes = data?.outcomes || [];

  return (
    <>
      <ErrorBanner error={error} />

      <Card title="Totals">
        <div className="stats-row">
          <Stat label="Contacts" value={totals.contacts ?? 0} />
          <Stat label="Analyses" value={totals.analyses ?? 0} />
          <Stat label="Feedback rows" value={totals.feedback ?? 0} />
          <Stat label="Engine runs" value={totals.engine_runs ?? 0} />
        </div>
      </Card>

      <Card title="Analyses per day (last 14 days)">
        {perDay.length === 0 ? <Empty>No data yet.</Empty> : (
          <SparkBars data={perDay} />
        )}
      </Card>

      <Card title="Reply outcomes">
        {outcomes.length === 0 ? <Empty>No feedback recorded yet.</Empty> : (
          <table>
            <thead><tr><th>Outcome</th><th>Count</th></tr></thead>
            <tbody>
              {outcomes.map((o, i) => (
                <tr key={i}>
                  <td>{o.outcome || '—'}</td>
                  <td>{o.n}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </>
  );
}

/* Token-friendly minimal bar chart — no chart library, no SVG library. */
function SparkBars({ data }) {
  const max = Math.max(1, ...data.map((d) => Number(d.n) || 0));
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 120 }}>
      {data.map((d) => {
        const h = Math.max(2, Math.round((Number(d.n) / max) * 110));
        return (
          <div key={d.day} style={{ flex: 1, textAlign: 'center' }} title={`${d.day}: ${d.n}`}>
            <div style={{
              height: h,
              background: 'var(--action-amber)',
              borderRadius: 'var(--radius-sm)',
            }} />
            <div style={{ fontSize: 'var(--type-utility)', color: 'var(--text-muted)', marginTop: 4 }}>
              {String(d.day).slice(5)}
            </div>
          </div>
        );
      })}
    </div>
  );
}
